import { render, staticRenderFns } from "./VolunteerEdit.vue?vue&type=template&id=e3b08234&scoped=true&lang=pug&"
import script from "./VolunteerEdit.vue?vue&type=script&lang=js&"
export * from "./VolunteerEdit.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerEdit.vue?vue&type=style&index=0&id=e3b08234&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b08234",
  null
  
)

export default component.exports